import React, { useState } from 'react';
import { api } from '../apiConfig';
import '../styles/UnifiedSearch.css'; // Reuse grid/button styles for consistency

const PublishGalleryButton = () => {
  const [loading, setLoading] = useState(false);
  const [published, setPublished] = useState(false);
  const [galleryUrl, setGalleryUrl] = useState('');
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);

  const handlePublish = async () => {
    setLoading(true);
    setError(null);
    setCopied(false);
    try {
      const res = await api.post('/artist/publish-gallery');
      setGalleryUrl(res.data.url);
      setPublished(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to publish gallery.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    if (galleryUrl) {
      navigator.clipboard.writeText(galleryUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div style={{
      background: '#fff',
      borderRadius: 'var(--radius-lg)',
      padding: '2rem',
      marginBottom: '2rem',
      boxShadow: '0 4px 24px 0 rgba(60,60,60,0.08)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '1rem'
    }}>
      <h2 style={{
        fontSize: '1.3rem',
        fontWeight: 600,
        margin: 0,
        color: 'var(--color-text-primary)'
      }}>
        Publish your online gallery
      </h2>
      <p style={{ color: 'var(--color-text-secondary)', margin: 0 }}>
        Create a public landing page with all your artworks. Share this link with collectors and fans!
      </p>
      {!published ? (
        <button
          className="publish-gallery-btn"
          style={{
            padding: '0.75rem 1.5rem',
            fontSize: '1rem',
            borderRadius: '8px',
            background: 'var(--color-accent)',
            color: 'white',
            fontWeight: 600,
            border: 'none',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1,
            marginTop: '0.5rem',
            transition: 'background 0.15s, color 0.15s'
          }}
          onClick={handlePublish}
          disabled={loading}
        >
          {loading ? 'Publishing...' : 'Publish your gallery'}
        </button>
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            marginBottom: '0.5rem',
            flexWrap: 'wrap'
          }}>
            <a
              href={galleryUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'var(--color-primary)',
                fontWeight: 600,
                textDecoration: 'underline',
                fontSize: '1.1rem',
                wordBreak: 'break-all'
              }}
            >
              {galleryUrl}
            </a>
            <button
              className="search-button"
              style={{
                padding: '0.5rem 1rem',
                fontSize: '0.95rem',
                borderRadius: '6px',
                background: 'var(--color-primary)',
                color: 'white',
                fontWeight: 500,
                border: 'none',
                cursor: 'pointer',
                marginLeft: '0.5rem'
              }}
              onClick={handleCopy}
            >
              {copied ? 'Copied!' : 'Copy link'}
            </button>
          </div>
          <div style={{ color: 'var(--color-success, #2ecc40)', fontWeight: 500 }}>
            Your gallery is live! Share this link with collectors.
          </div>
        </div>
      )}
      {error && <div style={{ color: 'var(--color-error, #e74c3c)', marginTop: '0.5rem' }}>{error}</div>}
    </div>
  );
};

export default PublishGalleryButton; 